module.exports = __webpack_public_path__ + "img/Frame 1103hrp8.9a3a6fc0.png";